import { createFileRoute, Outlet } from "@tanstack/react-router";

// Admin moved under /account. This route only exists so the old URLs still
// resolve — each child redirects to its new home.
export const Route = createFileRoute("/admin")({
	component: Outlet,
});
